import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAPIHandler from "../../hook/use-api-handler";
import { parseOnlyNumericValue, removeAllSpaces, removeMultipleSpace, removeSpecialCharAndNumFn1, removeUnderScrSpaceBet, safeToString, sliceText } from "../../utils/common";
import { logger } from "../../utils/logger";
import { REGISTRATION_INITIAL_STATE } from "./registration-constant";
import { RegistrationSchema } from "./registration-validation";

const useRegistrationService = ({ openSnackbar }) => {
    const navigate = useNavigate()
    const { fetchData } = useAPIHandler();
    const [signUpData, setSignUpData] = useState(REGISTRATION_INITIAL_STATE);
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
    };


    const handleSubmit = async () => {
        const {
            first_name,
            last_name,
            email,
            phone,
            user_type,
            password
        } = signUpData || {};
        const { error } = RegistrationSchema.validate({
            first_name,
            last_name,
            email,
            phone,
            user_type,
            password
        }, {
            abortEarly: false
        });

        if (error && error?.details?.length > 0) {
            const validationErrors = error.details.reduce((acc, err) => {
                const pathname = err.path.join(".");
                acc[pathname] = err.message;
                return acc;
            }, {});
            setErrors(validationErrors);
        } else {
            setErrors({});
            try {
                const url = "auth/signup";
                const payload = {
                    url: url,
                    method: 'POST',
                    data: {
                        first_name,
                        last_name,
                        email,
                        phone,
                        user_type,
                        password
                    }
                }
                const response = await fetchData(payload);
                if (response.status === "success") {
                    setSignUpData(REGISTRATION_INITIAL_STATE);
                    openSnackbar({ message: "SignUp successfully!" });
                    navigate("/");
                }

            } catch (error) {
                if (error?.type === "JoiValidationError") {
                    const errorsAll = {};
                    error?.errors?.reduce((acc, curr) => {
                        const { field, message } = curr;

                        errorsAll[field] = message;

                        return acc;
                    });
                    openSnackbar({
                        message:
                            Object.keys(errorsAll).length > 0
                                ? "Validation Error!"
                                : "Something went wrong!",
                        color: "danger",
                    });
                    setErrors(errorsAll);
                }
                else if (error?.type === "GeneralError") {
                    // const backendMessage = typeof error.message?.error === "string" 
                    //     ? error.message.error 
                    //     : "An unexpected error occurred.";
                    const backendMessage = typeof error.message === "string" 
                        ? error.message
                        : "An unexpected error occurred.";
                    
                    openSnackbar({
                        message: backendMessage,
                        color: "danger",
                    });
                }

                logger.log(error)

            }

        }
    }
    function handleBlurFn(e, name) {
        let value = e;

        if (e && e.target) {
            value = e.target.value;
        }

        const fieldSchema = RegistrationSchema.extract(name);
        const { error } = fieldSchema.validate(value);

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error ? error.details[0].message : undefined,
        }));
    }
    const handleChange = (e, name) => {
        // const { name, value } = e.target;
        let value = e;
        if (e && e.target) {
            value = e.target.value;
            name = e.target.name
        }
        if (name === "first_name") {
            value = sliceText(removeMultipleSpace(safeToString(removeSpecialCharAndNumFn1(value))), 150);
        }
        if (name === "last_name") {
            value = sliceText(removeMultipleSpace(safeToString(removeSpecialCharAndNumFn1(value))), 150);
        }
        if (name === "email") {
            value = sliceText(removeUnderScrSpaceBet(value.toLowerCase()), 150)
        }
        if (name === "phone") {
            value = sliceText(parseOnlyNumericValue(removeAllSpaces(value)), 10)
        }
        if (name === "password") {
            value = sliceText(value, 150)
        }

        setSignUpData((prevInfo) => ({
            ...prevInfo,
            [name]: value
        }));

        const fieldSchema = RegistrationSchema.extract(name);
        const { error } = fieldSchema.validate(value);
        if (!error) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: error ? error.details[0].message : undefined,
            }));
        }

    }
    return {
        handleSubmit,
        handleChange,
        errors,
        signUpData,
        handleBlurFn,
        togglePasswordVisibility,
        showPassword,
        openSnackbar
    }
}

export default useRegistrationService